import { LoginPage } from './pages/AuthenticationPages/LoginPage'

export { LoginPage }
